import React from 'react';
import WallCalendar from './WallCalendar';

export default function App() {
  return <WallCalendar />;
}